import { Injectable } from '@angular/core';
import { SettingsService } from './settings/settings.service';

@Injectable()
export class StorageService {

    public prefixo: string = 'HUB_';
    public static applicationDomain: string;
    private static storage: Storage = window.localStorage;

    public static get cookies(): Map<string, string> {
        return decodeURIComponent(document.cookie)
            .split(';')
            .reduce(
                (c, v) => {
                    const [key, ...value] = v.split('=');
                    return c.set(key.trim(), value.join('='));
                },
                new Map<string, string>(),
            );
    }

    /**
     * Retorna o valor de um cookie salvo se ele existir
     * @param cookieName nome do cookie
     */
    public static getCookie(cookieName: string) {
        return this.cookies.get(cookieName) || '';
    }

    /**
     * Cria um novo cookie no browser para o domain definido
     * @param key chave do cookie
     * @param value valor do cookie
     * @param expiresIn data de expiração
     */
    public static setCookie(key: string, value: string, expiresIn: Date = null, expiresType: string = 'expires') {

        let expiresInDate: string | Date = expiresIn;

        if (expiresType) {
            // Se não houver uma data para o cookie o mesmo
            // deve ser setado com a data do dia atual com horário de 23:59:59
            if (!expiresInDate) {
                expiresInDate = new Date();
                expiresInDate.setHours(23);
                expiresInDate.setMinutes(59);
                expiresInDate.setSeconds(59);
            }

            // Formato UTC
            expiresInDate = expiresInDate.toUTCString();
        }

        // Caso seja https, habilitar flag secure no cookie
        const secure: string = location.protocol.includes('https') ? 'secure;' : '';
        const expires: string = expiresType ? `${expiresType}=${expiresInDate}` : '';
        // Salva o cookie
        document.cookie = `${key}=${value};domain=${StorageService.applicationDomain};${secure}${expires};path=/`;

    }

    public static deleteCookie(cookieName: string) {
        if (StorageService.applicationDomain) {
            document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=' + StorageService.applicationDomain + ';path=/';
        } else {
            document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
        }
    }

    public static getSessionItem(sessionItem: string): string {
        return sessionStorage.getItem(sessionItem);
    }

    public static setSessionItem(key: string, value: string): void {
        sessionStorage.setItem(key, value);
    }

    public static removeSessionItem(sessionItem: string): void {
        sessionStorage.removeItem(sessionItem);
    }

    /**
     * Obtem dados localStorage através da chave
     * @param {string} key
     * @returns valor ou null
     */
    public static getLocalItem(key: string): any {
        if (StorageService.storage) {
            return StorageService.storage.getItem(key);
        }
        return null;
    }

    /**
     * Adiciona dados localStorage através da chave e valor
     * @param {string} key
     * @param {string} value
     * @returns true ou false
     */
    public static setLocalItem(key: string, value: string): boolean {
        if (StorageService.storage) {
            StorageService.storage.setItem(key, value);
            return true;
        }
        return false;
    }

    /**
     * Remove dados localStorage através da chave
     * @param {string} key
     * @returns true ou false
     */
    public static removeLocalItem(key: string): boolean {
        if (StorageService.storage) {
            StorageService.storage.removeItem(key);
            return true;
        }
        return false;
    }

    /**
     * Limpa todos os dados do localStorage
     * @returns true ou false
     */
    public static clearLocalItem(): boolean {
        if (StorageService.storage) {
            StorageService.storage.clear();
            return true;
        }
        return false;
    }
}
